import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

const getJsonAuthHeaders = () => ({
    ...getAuthorizationHeader(),
    Accept: "application/json",
    "Content-Type": "application/json",
});

export const reworkApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        createMoistureData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/moisture-room-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['moisture', 'toasted' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createReworkEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/rework/emp-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        getReworkLogs: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/rework/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cheeks', 'strips'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getGreenRoomLogs: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/green-room-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cheeks', 'strips', 'greenRoom'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getMoistureRoomLogs: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/moisture-room-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cheeks', 'strips', 'moisture'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getReworkEmployeeData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/rework/emp-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateReworkEmployeeData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/rework/emp-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employee' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateMoistureRoomData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/moisture-room-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['moisture', 'toasted','reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateGreenRoomData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/green-room-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['greenRoom', 'packingSummary' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateReworkLogData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/rework/log-update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['cheeks', 'strips', 'packingSummary','reworkAreaSummary','rework_packing_summary', 'ovenList','cheeks_strips_rework' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),

        createReworkPackingData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/rework/packing/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['cheeks_strips_rework', 'rework_packing_summary' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },
        }),

        getReworkPackingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/rework/packing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rework_packing_summary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getReworkAreaSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/rework/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['reworkAreaSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),


        //  New APi's For Rework Packing Section 

        getCheekStripPackedDataForRework: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/rework/packing/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cheeks_strips_rework'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getToastedSummary: build.query({
            query: (data = {}) => {
                const paramData = serialize(data);

                return {
                    url: `/rework/toasted/summary${paramData ? `?${paramData}` : ""}`,
                    method: 'GET',
                    headers: getJsonAuthHeaders(),
                };
            },
            providesTags: ['toasted'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getToastedLogs: build.query({
            query: (data = {}) => {
                const paramData = serialize(data);

                return {
                    url: `/rework/toasted/logs${paramData ? `?${paramData}` : ""}`,
                    method: 'GET',
                    headers: getJsonAuthHeaders(),
                };
            },
            providesTags: ['toasted'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createToastedLog: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/rework/toasted/create`,
                    method: 'POST',
                    headers: getJsonAuthHeaders(),
                    body: requestBody
                };
            },
            invalidatesTags: ['toasted' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Toasted log")
            },
        }),

        updateToastedLog: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/rework/toasted/update/${id}`,
                    method: 'PUT',
                    headers: getJsonAuthHeaders(),
                    body: requestBody
                };
            },
            invalidatesTags: ['toasted' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Toasted log")
            },
        }),

        updateToastedLogStatus: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/rework/toasted/status-update/${id}`,
                    method: 'PUT',
                    headers: getJsonAuthHeaders(),
                    body: requestBody
                };
            },
            invalidatesTags: ['toasted' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Toasted log status")
            },
        }),

        processAccumulatedData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/process-accumulated-data`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidLogs','greenRoomLogs','toasted' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Processed", "Accumulated Data");
            },
        }),

        getBaggingRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/bagging-record-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['baggingRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createBaggingRecord: build.mutation({
            query: (requestBody) => ({
                url: `/rework/bagging-record-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['baggingRecord','humidSummary' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Bagging Record");
            },
        }),

        updateBaggingRecord: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/bagging-record-update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['baggingRecord' ,'humidSummary','reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Bagging Record");
            },
        }),
        
        getReworkPackingBandRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/packing-band/record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['reworkPackingBandRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createReworkPackingBandRecord: build.mutation({
            query: (requestBody) => ({
                url: `/rework/packing-band/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['reworkPackingBandRecord' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Packing Band Record");
            },
        }),

        updateReworkPackingBandRecord: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/packing-band/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['reworkPackingBandRecord' ,'reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Packing Band Record");
            },
        }),


        //  ############### REWORK DASHBOARD ##################

        getReworkDashboardOverview: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/dashboard-overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['reworkDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    }),
});

export const {
    useCreateReworkEmployeeDataMutation,
    useUpdateReworkEmployeeDataMutation,
    useGetReworkEmployeeDataQuery,
    useGetReworkLogsQuery,
    useUpdateReworkLogDataMutation,
    useGetMoistureRoomLogsQuery,
    useCreateMoistureDataMutation,
    useUpdateMoistureRoomDataMutation,
    useGetGreenRoomLogsQuery,
    useUpdateGreenRoomDataMutation,
    useGetCheekStripPackedDataForReworkQuery,
    useCreateReworkPackingDataMutation,
    useGetReworkPackingSummaryQuery,
    useGetReworkAreaSummaryQuery,
    useGetToastedSummaryQuery,
    useGetToastedLogsQuery,
    useCreateToastedLogMutation,
    useUpdateToastedLogMutation,
    useUpdateToastedLogStatusMutation,
    useProcessAccumulatedDataMutation,
    useGetBaggingRecordQuery,
    useCreateBaggingRecordMutation,
    useUpdateBaggingRecordMutation,
    useGetReworkPackingBandRecordQuery,
    useCreateReworkPackingBandRecordMutation,
    useUpdateReworkPackingBandRecordMutation,
    useGetReworkDashboardOverviewQuery
} = reworkApi;